import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getLatestImports } from '../../api';
import { OrganizationTypeId } from '@sonar-software/sonar-ts-types';

export const importsLatestSalesforceSlice = createGetAsyncSlice({
	name: 'ImportsLatestSalesforce',
	receive: true,
	request: false,
	requestHandler: () => getLatestImports({
		count: 1,
		organizationTypeId: OrganizationTypeId.Salesforce
	}),
	retainDataOnRequest: true
});
